import { Injectable } from '@angular/core';
import { EmployeeHistoryItemEntity } from '../../domain/entities/employee-history-item.entity';
import { EmployeeProfileEntity } from '../../domain/entities/employee-profile.entity';
import { CaseHistoryResponseDto } from '../dtos/case-history-response.dto';
import { EmployeeProfileResponseDto } from '../dtos/employee-profile-response.dto';

@Injectable({ providedIn: 'root' })
export class Employee360Mapper {
  public toProfileEntity(dto: EmployeeProfileResponseDto): EmployeeProfileEntity {
    const entity = new EmployeeProfileEntity();
    entity.userId = dto.userId;
    entity.firstName = dto.firstName;
    entity.lastName = dto.lastName;
    entity.email = dto.email;
    entity.phone = dto.phone ?? '';
    entity.isActive = dto.isActive;
    entity.position = dto.position ?? '';
    entity.department = dto.department ?? '';
    return entity;
  }

  public toHistoryEntity(dto: CaseHistoryResponseDto): EmployeeHistoryItemEntity {
    const entity = new EmployeeHistoryItemEntity();
    entity.id = dto.id;
    entity.itemType = 'case';
    entity.displayId = dto.caseNumber;
    entity.title = dto.caseTypeName;
    entity.priority = dto.priorityCode;
    entity.status = dto.statusDisplayName;
    entity.createdDate = dto.createdOn;
    return entity;
  }
}
